import { FinancialAccountNode } from '../orgs/interfaces';
import { vaultRequest } from './request';
import OrgsService from '../orgs';

const GET_KYC_BY_ID_QUERY = `
query VaultKyc($vaultKycId: ID!) {
  vaultKyc(id: $vaultKycId) {
    email
    firstName
    id
    lastName
    phoneNumber
    ssn
    address {
      city
      postalCode
      region
      street
      unit
    }
    dob {
      day
      month
      year
    }
    percentOwnership
    title
    director
    executive
    representative
    owner
  }
}
`;

export const getKycById = async (vaultKycId: string): Promise<Kyc> => {
  const kycRes = await vaultRequest(GET_KYC_BY_ID_QUERY, {
    vaultKycId,
  });
  const kycData = await kycRes.json();
  if (kycData.errors) {
    throw new Error(kycData.errors.join(','));
  }
  return kycData.data.vaultKyc;
};

export const getKycIsInherited = async (
  kycId: string,
  financialAccountRoots: FinancialAccountNode[],
): Promise<boolean> => {
  let kycIsInherited = false;
  for (const financialAccountRoot of financialAccountRoots) {
    if (!financialAccountRoot.finAcctId) {
      continue;
    }
    const users = await OrgsService.getFinancialAcctUsers(
      financialAccountRoot.finAcctId,
    );
    const matchingUser = users.find((u) => u.kycId === kycId);
    if (matchingUser) {
      kycIsInherited = true;
      break;
    }
  }
  return kycIsInherited;
};

export const getPrimaryKycData = async (
  financialAccountId: string,
  provider: VaultProvider,
): Promise<{ kyc?: Kyc; stripePersonId?: string; userId?: string }> => {
  const financialAccountUsers =
    await OrgsService.getFinancialAcctUsers(financialAccountId);

  const financialAccountUser = financialAccountUsers.find(
    (fau) => fau.processor === provider.toUpperCase() && fau.isRepresentative,
  );

  let kyc: Kyc | undefined = undefined;
  if (financialAccountUser?.kycId !== undefined) {
    kyc = await getKycById(financialAccountUser.kycId);
  }

  return {
    kyc,
    stripePersonId: financialAccountUser?.personId,
    userId: financialAccountUser?.userId,
  };
};
